import * as types from './CapacityInputActionType';

// Fetch Capacity Input
export const fetchCapacityInputRequest = (params = {}) => ({
    type: types.FETCH_CAPACITY_INPUT_REQUEST,
    payload: params
});
export const fetchCapacityInputSuccess = (data) => ({
    type: types.FETCH_CAPACITY_INPUT_SUCCESS,
    payload: data
});
export const fetchCapacityInputFailure = (error) => ({
    type: types.FETCH_CAPACITY_INPUT_FAILURE,
    payload: error
});
 
// Fetch Default RAD Capacity
export const fetchDefaultRadCapacityRequest = () => ({
    type: types.FETCH_DEFAULT_RAD_CAPACITY_REQUEST
});
export const fetchDefaultRadCapacitySuccess = (data) => ({
    type: types.FETCH_DEFAULT_RAD_CAPACITY_SUCCESS,
    payload: data
});
export const fetchDefaultRadCapacityFailure = (error) => ({
    type: types.FETCH_DEFAULT_RAD_CAPACITY_FAILURE,
    payload: error
});
 
// Update RAD Capacity Input
export const updateRadCapacityInputRequest = (updateData) => ({
    type: types.UPDATE_RAD_CAPACITY_INPUT_REQUEST,
    payload: updateData
});
export const updateRadCapacityInputSuccess = (data) => ({
    type: types.UPDATE_RAD_CAPACITY_INPUT_SUCCESS,
    payload: data
});
export const updateRadCapacityInputFailure = (error) => ({
    type: types.UPDATE_RAD_CAPACITY_INPUT_FAILURE,
    payload: error
});
 
// Bulk Update RAD Capacity Input
export const bulkUpdateRadCapacityInputRequest = (bulkData) => ({
    type: types.BULK_UPDATE_RAD_CAPACITY_INPUT_REQUEST,
    payload: bulkData
});
export const bulkUpdateRadCapacityInputSuccess = (data) => ({
    type: types.BULK_UPDATE_RAD_CAPACITY_INPUT_SUCCESS,
    payload: data
});
export const bulkUpdateRadCapacityInputFailure = (error) => ({
    type: types.BULK_UPDATE_RAD_CAPACITY_INPUT_FAILURE,
    payload: error
});
 
// RAD Capacity IP Upload
export const radCapacityIpUploadRequest = (fileData) => ({
    type: types.RAD_CAPACITY_IP_UPLOAD_REQUEST,
    payload: fileData
});
export const radCapacityIpUploadSuccess = (data) => ({
    type: types.RAD_CAPACITY_IP_UPLOAD_SUCCESS,
    payload: data
});
export const radCapacityIpUploadFailure = (error) => ({
    type: types.RAD_CAPACITY_IP_UPLOAD_FAILURE,
    payload: error
});